import axios from 'axios'
import { MessageBox }  from 'element-ui'
const service = axios.create({
  // baseURL: 'http://192.168.1.223:8092/managementSystem/',
  // baseURL: 'http://192.168.1.181:8091/managementSystem/',
  // baseURL: 'http://192.168.1.10:8091/managementSystem/',
  // baseURL: 'https://card.xmgrwhg.org/managementSystem/',
  // baseURL: 'http://192.168.1.131:8092/managementSystem/',
  baseURL: 'https://zlesp.zlydgy.cn:443/managementSystem/',
  // baseURL: 'https://cs.xmgrwhg.org/managementSystem/',
  // baseURL: 'https://www.dooop.top/managementSystem/',
  // baseURL: 'https://localhost/managementSystem/',
  // baseURL: 'https://gymvip.bfsu.edu.cn/managementSystem/',

  // baseURL: 'https://www.147soft.cn/managementSystem/',
  // baseURL: 'https://www.wuhansport.com/managementSystem/',
  contentType: 'application/json',
  timeout: 15000 // 请求超时时间
})
service.interceptors.request.use(config => {
  let token = sessionStorage.getItem('token')
    //设置请求头
    if(token) {
        config.headers.token = token
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    return config
}, error => {
  Promise.reject(error)
})

service.interceptors.response.use(
  response => {
    const res = response.data
    if(res == -1){
      sessionStorage.removeItem('token')
      MessageBox.confirm('登录信息失效请重新登录', '登录超时', {
        confirmButtonText: '跳转登录页面',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.$router.push({path:'/login'})
        // window.location.href = 'http://192.168.1.166:8090/#/login'
        // window.location.href = 'https://www.147soft.cn/configAdmin/index.html#/login'
        // window.location.href = 'https://gymvip.bfsu.edu.cn/configAdmin/index.html#/login'
        // window.location.href = 'https://www.wuhansport.com/configAdmin/index.html#/login'
        // window.location.href = 'https://card.xmgrwhg.org/configAdmin/index.html#/login'
        window.location.href = 'https://zlesp.zlydgy.cn/configAdmin/index.html#/login'
        // window.location.href = 'https://cs.xmgrwhg.org/configAdmin/index.html#/login'
        // window.location.href = 'https://www.dooop.top/configAdmin/index.html#/login'
      })
    } else{
      return response.data
    }
  },
  error => {
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js